import { ButtonMantine, Center, Modal, Stack, Text, ThemeIcon } from 'ui';
import { IconCircleCheck } from 'ui/Icons';

const NPOCheckoutConfirmationModal = ({
  opened,
  onClose,
  cartId,
}: {
  opened: boolean;
  onClose: () => void;
  cartId?: string;
}) => {
  return (
    <Modal opened={opened} onClose={onClose} withCloseButton={false}>
      <Stack gap="lg">
        <Center>
          <ThemeIcon variant="transparent" size={64} color="mint.7">
            <IconCircleCheck size={64} />
          </ThemeIcon>
        </Center>
        <Stack gap="sm">
          <Text fz={20} fw={600}>
            Thank You For Your Order!
          </Text>
          <Text fz={12}>Order Number: {cartId}</Text>
        </Stack>
        <ButtonMantine mt="xs" fullWidth onClick={onClose}>
          Okay
        </ButtonMantine>
      </Stack>
    </Modal>
  );
};

export { NPOCheckoutConfirmationModal };
